<page-data-manager>
  <div class="flash-message-container">
    <flash-message></flash-message>
  </div>
  <div class="ibox-content border-bottom m-b-sm">
    <div class="row">
      <div class="col-xs-12">
        <div class='page-header'>
          <div class='btn-toolbar pull-right'>
            <div class='btn-group'>
              <a class="btn btn-primary btn-sm btn-action" href="#!/cadastro_propriedade/new" uib-tooltip="Nova Propriedade" tooltip-placement="left" ng-if="permissions.propriedades.canManage">
                Nova <i class="fa fa-plus"></i>
              </a>
            </div>
          </div>
          <h2>Propriedades</h2>
        </div>
      </div>
    </div>

    <form ng-submit="cadastroPropriedade.searchItems()" class="row">
      <div class="col-xs-12">
        <h3>Filtrar</h3>
      </div>
      <div class="col-xs-3 form-group">
        <select name="exibir" id="exibir" class="form-control" ng-model="cadastroPropriedade.search">
          <option value="all" selected="selected">Todos</option>
          <option value="active">Apenas ativos</option>
          <option value="inactive">Apenas inativos</option>
        </select>
      </div>
      <div class="col-xs-2">
        <div class="btn-group">
          <button type="submit" class="btn btn-success">
            <i class="fa fa-search"></i>
          </button>
        </div>
      </div>
    </form>
  </div>

  <div class="row">
    <div class="col-xs-12" ng-show="cadastroPropriedade.propriedades">
      <div class="panel panel-default">
        <div class="panel-body">

          <div class="row">
            <div class="col-xs-12">
              <small ng-show="cadastroPropriedade.propriedades.length == 0">Nenhuma propriedade encontrada!</small>

              <table class="table table-hover table-striped" ng-show="cadastroPropriedade.propriedades.length > 0">
                <thead>
                  <tr>
                    <th class="col-xs-11">Descrição</th>
                    <th class="col-xs-1"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr ng-repeat="propriedade in cadastroPropriedade.propriedades track by $index">
                    <td class="vertical-middle">{{::propriedade.descricao | capitalize}}</td>
                    <td class="vertical-middle text-right">
                      <div class="btn btn-primary btn-sm" ng-if="permissions.propriedades.canManage" ng-click="cadastroPropriedade.show($index)" uib-tooltip="Visualizar" tooltip-placement="top">
                        <i class="glyphicon glyphicon-eye-open"></i>
                      </div>

                      <div class="btn btn-primary btn-sm" ng-click="cadastroPropriedade.inactivate(propriedade.id)" uib-tooltip="Inativar Propriedade" tooltip-placement="top" 
                        ng-if="permissions.propriedades.canManage && !propriedade.dt_baixa">
                        <i class="glyphicon glyphicon-trash"></i>
                      </div>

                      <div class="btn btn-primary btn-sm" ng-click="cadastroPropriedade.activate(propriedade.id)" uib-tooltip="Ativar Propriedade" tooltip-placement="top" 
                        ng-if="permissions.propriedades.canManage && !!propriedade.dt_baixa">
                        <i class="glyphicon glyphicon-cog"></i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</page-data-manager>
